import React, {useState, useEffect, useCallback} from 'react'
import { useParams } from 'react-router-dom';
import {Spinner} from '@material-tailwind/react'
import { debounce, random } from 'lodash';
import toast, { Toaster } from 'react-hot-toast';
import { v4 as uuidv4 } from 'uuid';
import { useSelector, useDispatch } from 'react-redux';
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import moment from 'moment';

import { encodedAddressPrefix, tippingAddress, ownerAddress, royalty, tip, contentLength, serviceFeeRate, padding, royalty_pa, brc20BridgeFee } from '../../configs/constant';
import { Input } from '@material-tailwind/react'
import { formatAddress } from '../../util/format-data'
import FeeRateCard from '../FeeRateCard';
import { brc20PresaleFeeRate, brc20PresaleFee, brc20PresaleFeeAddress } from '../../configs/constant';
import { generateRandomKey } from '../../util/format-data';
import logoImg from '../../assets/imgs/🜸.png';
import { formatFloat } from '../../util/format-data';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Slider,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Progress
} from "@material-tailwind/react";

import { useWallet, useWallets } from '@wallet-standard/react';
import { useTranslation } from 'react-i18next';
import { getAllBrc20AdminList, getAllBrc20HistoryList, registerBrc20HistoryData, getBrc20Sum, removeBrc20HistoryData } from '../../util/brc20-api';

export default function Brc20Presale() {
  let param = "🝏";

  const { t, i18n } = useTranslation();
  const { wallets } = useWallets();

  const SatsConnectNamespace = 'sats-connect:';

  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const wallet = useSelector(state => state.wallet);

  const { Address, Script, Signer, Tap, Tx } = window.tapscript;
  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];

  const [timeLeft, setTimeLeft] = useState({});
//   const targetDate = moment.utc('2025-01-07T18:00:00');
  const [mintStart, setMintStart] = useState(true);

  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(0);
  const feeRates = useSelector(state => state.feeRate);
  const [feeValues, setFeeValues] = useState({
    "inscriptionFee": 0,
    "networkFee": 0,
    "serviceFee": 0,
    "royaltyFee": 0,
    "totalFee": 0
  });
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [domain, setDomain] = useState('');
  const [amount, setAmount] = useState(10000);
  const [maximum, setMaximum] = useState(21000);
  const [sum, setSum] = useState(0);
  const [deployLimit, setDeployLimit] = useState(21000);
  const [address, setAddress] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [key, setKey] = useState('');
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);
  const [show, setShow] = useState(false);
  const [inscriptionStatus, setInscriptionStatus] = useState(false);

  const [ticker, setTicker] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [receiveAddress, setReceiveAddress] = useState("");
  const [minAmount, setMinAmount] = useState(0);
  const [mintEnd, setMintEnd] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [currentSum, setCurrentSum] = useState(0);
  const [description, setDescription] = useState("");
  const [btcAmount, setBtcAmount] = useState(0.001);
  const [percent, setPercent] = useState(0);
  const [hardCap, setHardCap] = useState(0.05);
  const [softCap, setSoftCap] = useState(0.01);

  const [flag, setFlag] = useState(1);

  useEffect(() => {
    handleMintTickers();
    handleTotalAmount();
  }, [])

  useEffect(() => {
    setAmount(Math.ceil(parseFloat(btcAmount) * Math.pow(10, 8)))
  }, [btcAmount])

  const handleMintTickers = async () => {
    let results = await getAllBrc20AdminList(param);
    getPATokenAdmin(results.data[0])
  }

  const handleTotalAmount = async () => {
    let results = await getBrc20Sum("", param);
    let temp = results.sum ?? 0;
    setTotalAmount(parseInt(temp));
  }

  const getPATokenAdmin = async (tickerData) => {
    setReceiveAddress(tickerData.receiveAddress);
    setMinAmount(tickerData.minAmount);
    setDescription(tickerData.description);
    let startTimes = tickerData.startTime.split('-');
    setStartTime(startTimes[0] + '-' + startTimes[1] + '-' + startTimes[2] + 'T' + startTimes[3] + ':00:00');
    let endTimes = tickerData.endTime.split('-');
    setEndTime(endTimes[0] + '-' + endTimes[1] + '-' + endTimes[2] + 'T' + endTimes[3] + ':00:00');
    setTicker(tickerData.ticker);
    setHardCap(tickerData.hardCap);
    setSoftCap(tickerData.softCap);
  }

  useEffect(() => {
    let intervalId;

    const updateFees = async () => {
      try {
        if (feeRateMode == "Custom") {
          setFeerate(customFee);
        }
        else
        {
          setFeerate(feeRates[feeRateMode]);
          if (customFee == 0) 
          {
            setCustomFee(feeRates["Fast"] + 1);
          }
        }
      }
      catch (e) {
        console.log(e);
      }
    }
    updateFees();
    intervalId = setInterval(updateFees, 20 * 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, [feeRateMode, customFee])

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValue])

  useEffect(() => {
    updateTokens(key, page);
  }, [page, ticker])

  useEffect(() => { 
    handleAddress(wallet.nostrOrdinalsAddress);
  }, [wallet.nostrOrdinalsAddress]);

  const updateTokens = async (value, offset) => {
    setLoading(true);
    let data = await getAllBrc20HistoryList(value, ticker, offset, limit);

    setTokens(data.data);
    setTotal(Math.ceil(data.total / limit))
    setLoading(false);
  }

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  const debouncedSearch = useCallback(debounce((value) => {
    setPage(1);
    updateTokens(value, 1)
  }, 300), []); 

  const handleSearch = (value) => {
    setKey(value);
    debouncedSearch(value);
  };

  const handleMint = async () => {
    setLoading(true);

    if (amount != parseInt(amount) || parseInt(amount) < 1) {
      toast.error(t('Insert Valid Amount Error Message'));
      setLoading(false);
      return;
    }

    if (amount < brc20PresaleFee ) {
      toast.error(t('Presale Amount Error Message'));
      setLoading(false);
      return;
    }

    if (wallet.nostrOrdinalsAddress == "")
    {
      toast.error(t('Connect Wallet Error Message'));
      setLoading(false);
      return;
    }

    if (address == "") {
      toast.error(t('Insert Inscription Address Error Message'));
      setLoading(false);
      return;
    }
    

    let isSuccess = true;

    let serviceFee = parseInt(amount) * brc20PresaleFeeRate;
    let totalFee = 0;
    if (brc20PresaleFeeAddress == receiveAddress) {
      totalFee = parseInt(amount) + serviceFee;
      serviceFee = 0;
    }
    else {
      totalFee = parseInt(amount);
      if (serviceFee < 5000) serviceFee = 5000;
    }

    let tempfeerate = feerate;
    if (tempfeerate == "") tempfeerate = feeRates[feeRateMode];
    if (wallet.domain == "xverseWallet") tempfeerate = Math.ceil(feerate * 1.2);

    if (tempfeerate == null || tempfeerate == undefined || isNaN(tempfeerate)) {
      tempfeerate = 1.1;
    }

    let fundingAddressList = [];
    fundingAddressList.push(receiveAddress);
    
    if (isSuccess) {
    let params = {
        ticker: param,
        address: address,
        amount: amount,
        randomKey: generateRandomKey(40)
    }
    await registerBrc20HistoryData(params);
    await handleTotalAmount();
    await handleCurrentSum(address);

    toast.success(t('Success!'));
    await updateTokens(key, page);
    }

    setLoading(false);
    setShow(false);
  }

  const handleCustomFee = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setCustomFee(sanitizedValue);
  }

  const debouncedAddressSearch = useCallback(debounce( async (value) => {
    await handleCurrentSum(value);
  }, 800), []); 

  const handleCurrentSum = async (value) => {
    let result = await getBrc20Sum(value, param);
    let sum = result.sum ?? 0;
    setCurrentSum(parseInt(sum));
  }

  const handleAddress = (value) => {
    setAddress(value)
    debouncedAddressSearch(value)
  }

  const handleCopy = (value, mode) => {
    navigator.clipboard.writeText(value).then(
      () => {
        // Successfully copied to clipboard
        if (mode == 1)
          toast.success(t('Name Copied!'));
        else
          toast.success(t('Address Copied!'));
      },
      (err) => {
        // Failed to copy to clipboard
        console.error('Could not copy address: ', err);
      }
    );
  }

  const calculateFeeRandom = (feeRate, _mintCount, dataSize = contentLength ) => {
    let mintCount = parseInt(_mintCount);
    if (mintCount <= 0 || mintCount == NaN) mintCount = 1;
    let base_size = 160;
    let prefix = 160;
    let txsize = prefix + Math.floor(dataSize / 4);
    let inscriptionLength = mintCount;
    let inscriptionFee = padding ;
    let networkFee = Math.floor(feeRate * txsize);
  
    let royaltyFee = royaltyCost * mintCount;

    let serviceFee = 0;
    let totalFee = royaltyFee;
    return {
      "inscriptionFee": inscriptionFee,
      "networkFee": networkFee,
      "serviceFee": serviceFee,
      "royaltyFee": royaltyFee,
      "totalFee": totalFee
    }
  }  

  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const handleRemove = async (data) => {
    setLoading(true);
    data.ticker = param;
    await removeBrc20HistoryData(data);
    await updateTokens(key, page);
    await handleTotalAmount();
    await handleCurrentSum(address);
    setLoading(false);
  }

  return (
    <div className="text-white mt-[65px] w-full max-w-[1500px] md:px-7 px-2 flex flex-col justify-center items-center mb-10 min-h-[600px]">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed" color="pink"/> : <></>
      }
      <img src={`https://bitcoinuniverse.io/img/brc20/${param}.png`} className="w-[80px] rounded-md"/>
      <div className="flex flex-row text-primary max-w-[600px] mt-3 font-bold text-[18px]">
        {description}
      </div>
      <div className="sm:w-[600px] w-full flex flex-col gap-1 text-white font-semibold sm:text-[20px] md:text-[18px] text-[16px] mt-5 py-2 md:px-4 px-2 border-[1px] border-dashed border-gray-800 rounded-lg">
        <div className="flex flex-row justify-between">
          {
            totalAmount > softCap * Math.pow(10, 8) ?
            <span className="ml-3">{t('Progress')} ({ !parseInt(minAmount) ? 0 :  parseInt(totalAmount) > parseInt(minAmount) ? 100 : Math.floor(parseInt(totalAmount) * 10000 / parseInt(minAmount)) / 100}%)</span>
            :
            <span className="ml-3">{t('Progress')} ({ !parseInt(minAmount) ? 0 :  parseInt(totalAmount) > parseInt(minAmount) ? 100 : Math.floor(parseInt(totalAmount) * 10000 / parseInt(softCap * Math.pow(10, 8))) / 100}%)</span>
          }
          <span>Soft Cap: {softCap} BTC</span>
        </div>
        {
          totalAmount > softCap * Math.pow(10, 8) ?
          <Progress  value={Math.ceil(parseInt(totalAmount) * 100 / parseInt(minAmount))} color="pink" size="md" className="bg-blue-800" />
          :
          <Progress  value={Math.ceil(parseInt(totalAmount) * 100 / parseInt(softCap * Math.pow(10, 8)))} color="blue" size="md" />
        }
        <div className="flex flex-row justify-between">
          <span className="ml-3">{totalAmount / Math.pow(10, 8)} BTC {t('Raised')}</span>
          <span>Hard Cap: {hardCap} BTC</span>
        </div>
      </div>

      <div className="md:min-w-[600px] min-w-[300px] border-gray-800 border-[1px] border-solid p-8 rounded-lg mt-5 flex flex-col gap-8 bg-[#081817] md:w-[600px] w-full">
        <div>
          <Input type="text" color="white" label = {t('Presale Amount')} className="w-full md:min-w-[500px] min-w-[250px]" value={btcAmount} onChange = {(e) => {setBtcAmount(e.target.value)}}/>
        </div>
        <div>
          <Input type="text" color="white" label = {t('Receive Address')} className="w-full md:min-w-[500px] min-w-[250px]" value={address} onChange = {(e) => {handleAddress(e.target.value)}}/>
        </div>
        <div className="sm:text-[18px] text-[14px]">
          {t('Select Network Fee You Want')}:
        </div>
        <div className="grid grid-cols-3 gap-3">
          <FeeRateCard header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
          <FeeRateCard header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
          <FeeRateCard header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
        </div>
        {
          feeRateMode == "Custom" ? 
          <div className="flex flex-row gap-3 items-center">
            <Slider className="sm:flex hidden" color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
            <div className="sm:max-w-[200px] w-full">
              <Input type="text" color="white" label = {t('Custom Fee')} className="sm:max-w-[200px] w-full" value={customFee} onChange = {(e) => {handleCustomFee(e.target.value)}}/>
            </div>
          </div>
          : 
          <></>
        }
        {/* <div className="m-auto md:w-[400px] w-[250px]">
          <div className="flex flex-row justify-between mt-1 sm:text-[20px] text-[14px]">
            <div className="font-bold">{t('Total Cost')}</div>
            <div className="text-right font-bold text-blue-600">{feeValues["totalFee"] / Math.pow(10, 8)} BTC</div>
          </div> 
        </div> */}
        <div className="flex flex-row gap-2 text-[18px]">
          Adding <span className="font-bold text-white">{btcAmount} BTC</span>
        </div>
        <div>
          You total investment will be <span className="text-primary font-bold">{formatFloat(currentSum / Math.pow(10, 8) + parseFloat(btcAmount), 6)}BTC</span>, that currently corresponds to <span className="text-primary font-bold">{ parseInt(((currentSum + parseInt(amount)) / (totalAmount + parseInt(amount))) * 10000) / 100}%</span> of the total presale supply.
        </div>
        <div className="flex flex-row w-full justify-center">
          <button className="bg-primary hover:bg-primary-hover rounded-md py-2 min-w-[240px]" onClick={handleMint}>{t('SUBMIT')}</button>
        </div>
      </div>
      {
        flag == 1 ?
        <div className="md:min-w-[600px] min-w-[300px] flex flex-col mt-10 mb-10 md:w-[600px] w-full">
          {/* <div className="w-full flex flex-row justify-between border-b-[1px] border-b-[#24242a] pb-1 mb-3">
            <div className="font-bold sm:text-lg text-md text-right">
              {t('Completed')}: <span className="font-bold sm:text-xl text-lg  text-primary">{sum}</span>
            </div>
            <div className="font-bold sm:text-lg text-md text-right">
              {t('Available')}: <span className="font-bold sm:text-xl text-lg  text-primary">{royaltyLimit - sum}</span>
            </div>
          </div> */}
          <Input type="text" color="white" label = {t('Search by address')} className="w-full md:min-w-[500px] min-w-[250px]" value = {key}
                      onChange = {(e) => {handleSearch(e.target.value)}}/>
          <div className="w-full border-gray-800 border-[1px] border-solid rounded-lg mt-4 bg-[#081817]">
            <div className="w-full grid grid-cols-3 py-4 px-6 bg-[#1e1f1f]">
              <div>{t('Address')}</div>
              <div>{t('Amount')}</div>
              <div>{t('Action')}</div>
            </div>
            {
              tokens.length == 0 ? <div className="w-full flex flex-row py-4 px-6 text-gray-500 hover:bg-[#121313] justify-center">{t('No Mint Tokens')}</div> : 
              <>
                {
                  tokens.map((data) => {
                    return (
                      <div className="w-full grid grid-cols-3 py-4 px-6 text-gray-500 hover:bg-[#121313] cursor-pointer items-center" key={uuidv4()}>
                        <div onClick={() => handleCopy(data.address, 2)}>{formatAddress(data.address)}</div>
                        <div>{parseInt(data.amount) / Math.pow(10, 8)} BTC</div>
                        <div className="bg-gray-800 text-white font-bold p-2 rounded-md text-center cursor-pointer" onClick={() => handleRemove(data)}>{t('REMOVE')}</div>
                      </div>
                    )
                  })
                }
              </>
            }
          </div>
          {
            total > 1 ? 
            <div className="flex flex-row items-center gap-8 justify-end mt-5">
              <IconButton
                size="sm"
                variant="outlined"
                onClick={prev}
                disabled={page === 1}
                className="bg-primary hover:bg-primary-hover"
              >
                <ArrowLeftIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
              <Typography color="white" className="font-normal">
                {t('Page')} <strong className="text-primary">{page}</strong> of{" "}
                <strong className="text-primary">{total}</strong>
              </Typography>
              <IconButton
                size="sm"
                variant="outlined"
                onClick={next}
                disabled={page === total}
                className="bg-primary hover:bg-primary-hover"
              >
                <ArrowRightIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
            </div>
            :
            <></>
          }
        </div>
        :
        <></>
      }
    </div>
  )
}
